import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Calendar } from 'lucide-react';
import { format } from 'date-fns';
import { config } from '../config';

export default function MaintenancePage() {
  const { id } = useParams<{ id: string }>();
  const [maintenance, setMaintenance] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMaintenance();
  }, [id]);

  async function fetchMaintenance() {
    try {
      const apiUrl = config.apiUrl;
      const res = await fetch(`${apiUrl}/v1/stats/maintenances/${id}`);

      if (res.ok) {
        const data = await res.json();
        setMaintenance(data.maintenance);
      }
    } catch (error) {
      console.error('Failed to fetch maintenance', error);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="relative">
          <div className="w-10 h-10 border-2 border-gray-200 rounded-full" />
          <div className="absolute inset-0 w-10 h-10 border-2 border-transparent border-t-unlimit-lime rounded-full animate-spin" />
        </div>
      </div>
    );
  }

  if (!maintenance) {
    return (
      <div className="text-center py-16">
        <h2 className="text-xl font-bold text-navy-900">Maintenance not found</h2>
        <Link to="/" className="text-sm text-navy-900 hover:text-unlimit-lime-dark mt-4 inline-block font-medium">
          Return to status page
        </Link>
      </div>
    );
  }

  return (
    <div className="space-y-6 animate-fade-in-up">
      <Link to="/" className="inline-flex items-center text-sm text-gray-500 hover:text-navy-900 transition-colors font-medium">
        <ArrowLeft className="h-4 w-4 mr-1.5" />
        Back to status
      </Link>

      <div className="bg-white rounded-2xl shadow-card border border-gray-100 p-6">
        <div className="flex items-start justify-between mb-5">
          <div>
            <h1 className="text-xl font-bold text-navy-900">{maintenance.title}</h1>
            {maintenance.summary && (
              <p className="text-sm text-gray-500 mt-1.5">{maintenance.summary}</p>
            )}
          </div>
        </div>

        {maintenance.scheduled_start && maintenance.scheduled_end && (
          <div className="flex items-center space-x-2 text-sm text-gray-500 bg-unlimit-gray-light px-4 py-3 rounded-xl">
            <Calendar className="h-4 w-4 text-gray-400" />
            <span className="font-medium text-navy-900">
              {format(new Date(maintenance.scheduled_start), 'PPp')}
            </span>
            <span className="text-gray-400">&mdash;</span>
            <span className="font-medium text-navy-900">
              {format(new Date(maintenance.scheduled_end), 'PPp')}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
